var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyedrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.513,
    height: 15.513,
    viewBox: "0 0 15.513 15.513",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "eyedrop",
    "data-name": "Eyedrop",
    d: "M17.516,2.5a1.939,1.939,0,0,0-2.742,0L12.166,5.1,10.327,3.265,8.271,5.322,9.883,6.934,2.73,14.086a.544.544,0,0,0-.156.446h0v2.424a.485.485,0,0,0,.485.485H5.54a.544.544,0,0,0,.386-.16l7.152-7.152,1.612,1.612,2.057-2.057L14.908,7.846l2.608-2.608A1.939,1.939,0,0,0,17.516,2.5ZM5.193,16.472H3.54V14.819l7.114-7.114,1.653,1.653Z",
    transform: "translate(-2.571 -1.928)",
    fill: "#7b7b7b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyedrop);
export default __webpack_public_path__ + "static/media/eyedrop.4de29d52b38d856fbd9a3db61319e9b6.svg";
export { ForwardRef as ReactComponent };